import axios from 'axios';
import env from '../../env-config.json';
import { serviceOptions } from './index';
const AUTH_REFRESH_STATUSES = [401, 403];
export default (token, refreshAccessToken) => {
  const instance = axios.create({
    headers: {
      Authorization: `Bearer ${token}`
    },
    baseURL: env.integrations.gateway_host,
    timeout: 90000 // TODO: Fix this after Entity framework has been fixed on BE
  });
  if (refreshAccessToken) {
    instance.interceptors.response.use(response => response, async error => {
      const status = error.response?.status;
      const requestConfig = error.config;
      if (!requestConfig) return Promise.reject(error);
      if (!status || !AUTH_REFRESH_STATUSES.includes(status) || requestConfig.retryRequest) return Promise.reject(error);
      requestConfig.retryRequest = true;
      const refreshedAccessToken = await refreshAccessToken();
      if (!refreshedAccessToken) return Promise.reject(error);
      instance.defaults.headers.Authorization = `Bearer ${refreshedAccessToken}`;
      requestConfig.headers = {
        ...(requestConfig.headers ?? {}),
        Authorization: `Bearer ${refreshedAccessToken}`
      };
      return instance.request(requestConfig);
    });
  }
  serviceOptions.axios = instance;
};